import React from "react";

import { Search } from "lucide-react";

import "./style.scss";

interface SearchInputProps {
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  rounded?: "full" | "normal";
  size?: "default" | "sm";
}

const SearchInput: React.FC<SearchInputProps> = props => {
  const {
    placeholder = "Search",
    value,
    onChange,
    rounded = "full",
    size = "default",
  } = props;

  return (
    <div className="search-bar-wrapper">
      <div
        className={`flex input-group ${rounded === "normal" ? "input-group-normal" : ""} ${size === "sm" ? "input-group-sm" : ""}`}
      >
        <div
          className={`flex items-center input-group-text ${size === "sm" ? "px-2" : "px-3"}`}
        >
          <Search
            className={`${size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} text-gray-500`}
          />
        </div>
        <input
          placeholder={placeholder}
          className="search-input w-full"
          value={value}
          onChange={onChange}
          type="search"
          name="search"
          autoComplete="off"
        />
      </div>
    </div>
  );
};

export default SearchInput;
